import { Avatar, Box, Grid, Icon, Paper, Typography } from "@material-ui/core";
import Loading from "customHooks/useCompleoForm/helpers/Loading";
import React from "react";
import { createStyles, Theme, makeStyles } from "@material-ui/core/styles";
import Timeline from "@material-ui/lab/Timeline";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";
import TimelineDot from "@material-ui/lab/TimelineDot";
import useJobContext from "../useJobContext";
import {
    getIconByHistoryType,
    IJobHistoryProps,
    getColorByHistoryType,
    getSizeByHistoryType
} from "./JobHistoryHelper";
import JobHistoryChangeStatus from "./Items/JobHistoryChangeStatus";
import JobHistoryComment from "./Items/JobHistoryComment";
import { TimelineOppositeContent } from "@material-ui/lab";
import { transformDBData } from "functions/util";
import Skeleton from "@material-ui/lab/Skeleton";
import JobHistoryLoading from "./Items/JobHistoryLoading";
import CachedIcon from "@material-ui/icons/Cached";

const useStyles = (dotColor: string, heightRoot: number) => {
    return makeStyles((theme: Theme) =>
        createStyles({
            "@keyframes rotation": {
                from: {
                    transform: "rotate(0deg)"
                },
                to: {
                    transform: "rotate(359deg)"
                }
            },
            root: { margin: theme.spacing(2) },
            paper: { padding: theme.spacing(2) },
            timeDot: {
                borderColor: dotColor,
                backgroundColor: dotColor,
                animation: "rotation 2s infinite linear"
            },
            icon: {
                color: "white",
                animation: "rotation 2s infinite linear"
            },
            content: { height: heightRoot }
        })
    );
};

const JobHistoryTimelineItemLoading = (props: IJobHistoryProps) => {
    const { historyItem } = props;
    const color = getColorByHistoryType(historyItem?.type);
    const heightItem = getSizeByHistoryType(
        historyItem?.type,
        historyItem?.comment !== undefined
    );
    const classes = useStyles(color, heightItem)();

    return (
        <TimelineItem className={classes.root}>
            <TimelineOppositeContent style={{ flex: 0.2 }}>
                <Skeleton variant="text" width="100%" />
            </TimelineOppositeContent>
            <TimelineSeparator>
                <TimelineDot variant="default" className={classes.timeDot}>
                    <CachedIcon className={classes.icon} />
                </TimelineDot>
                <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent className={classes.content}>
                <JobHistoryLoading />
            </TimelineContent>
        </TimelineItem>
    );
};

export default JobHistoryTimelineItemLoading;
